import {
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
} from "@azure/msal-react";
import { Toast } from "primereact/toast";
import React, { Suspense, useEffect, useRef } from "react";
import { BrowserRouter as Router } from "react-router";
import "./App.css";
import {
  listenForMessages,
  requestPermissionAndGetToken,
} from "./config/firebase/firebase-messaging.ts";
import toastService from "./shared/components/common/toast/toastService.ts";
import TransactionToast from "./shared/components/common/toast/TransactionsToast.tsx";
import { TimezoneProvider } from "./contexts/TimeZoneContext.tsx";
import { CostReportNotificationProvider } from "./contexts/CostReportNotification.tsx";
import { SignalRProvider } from "./contexts/SignalRContext.tsx";
import { AccessDeniedScreen } from "./features/static/pages/AccessDeniedScreen.tsx";
import { AppRoutes } from "./routes/AppRoutes.tsx";
import { useAppAuth } from "./shared/hooks/useAppAuth.ts";
interface MainContentProps {
  toastRef: React.RefObject<Toast | null>;
  transToast: React.RefObject<Toast | null>;
}

const MainContent: React.FC<MainContentProps> = ({ toastRef, transToast }) => {
  const { jwtReady, accessDenied, accessDeniedMessage, handleLogout } = useAppAuth();

  return (
    <div>
      <AuthenticatedTemplate>
        <Toast ref={toastRef} position="bottom-right" />
        <Toast ref={transToast} position="bottom-center" />

        {accessDenied && (
          <AccessDeniedScreen
            message={accessDeniedMessage}
            onSignOut={handleLogout}
          />
        )}

        {jwtReady && (
          <Router>
            <SignalRProvider>
              <TimezoneProvider>
                <CostReportNotificationProvider>
                  <Suspense
                    fallback={
                      <div className="flex items-center justify-center h-screen">
                        Loading...
                      </div>
                    }
                  >
                    <AppRoutes handleLogout={handleLogout} jwtReady={jwtReady} />
                  </Suspense>
                </CostReportNotificationProvider>
              </TimezoneProvider>
            </SignalRProvider>
          </Router>
        )}
      </AuthenticatedTemplate>

      <UnauthenticatedTemplate>
        <div className="flex items-center justify-center h-screen text-[var(--text-tertiary)]" />
      </UnauthenticatedTemplate>
    </div>
  );
};

function App() {
  const toastRef = useRef<Toast>(null);
  const TranscToastRef = useRef<Toast>(null);

  useEffect(() => {
    toastService.setToast(toastRef);
    TransactionToast.setToast(TranscToastRef);
    requestPermissionAndGetToken();
    listenForMessages();

    if ("serviceWorker" in navigator) {
      navigator.serviceWorker
        .register("/firebase-messaging-sw.js")
        .catch((err) => console.error("Service Worker registration failed:", err));
    }
  }, []);

  return <MainContent toastRef={toastRef} transToast={TranscToastRef} />;
}

export default App;
